/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-how-to-text',
  templateUrl: './how-to-text.page.html',
  styleUrls: ['./how-to-text.page.scss']
})
export class HowToTextPage implements OnInit {
  isAndroid = false;

  constructor(
    private platform: Platform,
    private modalCtrl: ModalController
  ) {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  init() {
    this.isAndroid = this.platform.is('android');
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
